import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import { IInputProps } from 'react-dropzone-uploader/dist/Dropzone'
import uploadIcon from '../../../images/upload-logo.png'

function DropZoneInput({ accept, onFiles, getFilesFromEvent }: IInputProps) {
  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      <Grid
        item
        style={{
          width: 97,
          height: 82,
          backgroundSize: 'contain',
          backgroundImage: `url('${uploadIcon}')`,
        }}
      />
      <Grid item sx={{ pt: 3, textAlign: 'center' }}>
        <Typography sx={{ color: '#A5CAEE', fontSize: '20px' }}>Drop your File and Upload</Typography>
        <Typography variant="body2" sx={{ color: '#A5CAEE', fontSize: '16px' }}>
          Or
        </Typography>
        &nbsp;
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>
          <Typography variant="body2" sx={{ color: '#007bff', cursor: 'pointer', fontSize: '16px' }}>
            Browse
          </Typography>
          <input
            style={{ display: 'none' }}
            type="file"
            accept={accept}
            multiple
            onChange={(e) => {
              getFilesFromEvent(e).then((chosenFiles) => {
                onFiles(chosenFiles)
              })
            }}
          />
        </label>
        <Typography sx={{ mt: 1, color: '#A5CAEE', fontSize: '12px' }}>Maximum 5 MiB</Typography>
        <Typography sx={{ color: '#A5CAEE', fontSize: '12px' }}>only png / jpg</Typography>
      </Grid>
    </Grid>
  )
}

export default DropZoneInput
